import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { applyTheme } from "../theme/colors";

const ThemeContext = createContext();

const STORAGE_KEY = "garment_dark_mode";

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "true";
  });

  // Counter to notify consumers that theme changed (without unmounting children)
  const [themeKey, setThemeKey] = useState(0);

  useEffect(() => {
    applyTheme(isDark);
    localStorage.setItem(STORAGE_KEY, String(isDark));
    setThemeKey(k => k + 1);
  }, [isDark]);

  // Apply on mount
  useEffect(() => { applyTheme(isDark); }, []);

  const toggle = useCallback(() => setIsDark(d => !d), []);

  return (
    <ThemeContext.Provider value={{ isDark, toggle, themeKey }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}